import { CIcon } from '~/icons/types'

export const ciStarFull: CIcon = {
  width: '24',
  height: '23',
  paths: [
    {
      d:
        'm10.713.8-2.93 5.939-6.554.955c-1.175.17-1.646 1.62-.794 2.45l4.742 4.62-1.122 6.527c-.202 1.18 1.041 2.064 2.082 1.512L12 19.721l5.863 3.082c1.04.547 2.284-.332 2.082-1.512l-1.122-6.527 4.742-4.62c.852-.83.381-2.28-.794-2.45l-6.554-.955-2.93-5.94c-.524-1.058-2.045-1.072-2.575 0Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'star-full',
  type: 'regular'
}
